import React from 'react';
import { CATEGORIES } from './shapeLibrary';

// Icons of the shape library sidebar (from its design). Line icons take the text colour.
const LINE = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const CollapseIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
        <rect x="3.5" y="4.5" width="17" height="15" rx="3" />
        <path d="M9.5 4.5v15M15.5 10l-2 2 2 2" />
    </svg>
);

export const ExpandIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
        <rect x="3.5" y="4.5" width="17" height="15" rx="3" />
        <path d="M9.5 4.5v15M13.5 10l2 2-2 2" />
    </svg>
);

export const SearchIcon = ({ size = 18 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
        <circle cx="11" cy="11" r="6.5" />
        <path d="M16 16l4 4" />
    </svg>
);

export const ClearIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" {...LINE} strokeWidth="2.6">
        <path d="M6 6l12 12M18 6L6 18" />
    </svg>
);

export const NoResultsIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
        <circle cx="11" cy="11" r="6.5" />
        <path d="M16 16l4 4M8.5 11h5" />
    </svg>
);

export const HandIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" {...LINE}>
        <path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V11M12 10V4.5a1.5 1.5 0 0 1 3 0V11M15 10.5V6.5a1.5 1.5 0 0 1 3 0V14a7 7 0 0 1-7 7h-.6a6 6 0 0 1-4.6-2.2L3.5 16a1.6 1.6 0 0 1 2.4-2.1L9 16.5V8.5a1.5 1.5 0 0 1 3 0" />
    </svg>
);

export const MoreIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <circle cx="6" cy="12" r="1.8" />
        <circle cx="12" cy="12" r="1.8" />
        <circle cx="18" cy="12" r="1.8" />
    </svg>
);

// A library shape, filled and outlined in its category's colours.
export const ShapeIcon = ({ shape, size = 30 }) => {
    const { fill, stroke } = CATEGORIES[shape.category];
    return (
        <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
            <path d={shape.icon} fill={fill} stroke={stroke} strokeWidth="2" strokeLinejoin="round" />
        </svg>
    );
};
